export const GET_INSURANCE_COMPANY_BY_SLUG_REQUEST = 'GET_INSURANCE_COMPANY_BY_SLUG_REQUEST';
export const GET_INSURANCE_COMPANY_BY_SLUG_SUCCESS = 'GET_INSURANCE_COMPANY_BY_SLUG_SUCCESS';
export const GET_INSURANCE_COMPANY_BY_SLUG_FAILURE = 'GET_INSURANCE_COMPANY_BY_SLUG_FAILURE';

export const getInsuranceCompanyBySlugRequest = ({ slug }) => ({
  type: GET_INSURANCE_COMPANY_BY_SLUG_REQUEST,
  payload: { slug }
});

export const getInsuranceCompanyBySlugSuccess = ({ insuranceCompany }) => ({
  type: GET_INSURANCE_COMPANY_BY_SLUG_SUCCESS,
  payload: {
    insuranceCompany
  }
});

export const getInsuranceCompanyBySlugFailure = (error) => ({
  type: GET_INSURANCE_COMPANY_BY_SLUG_FAILURE,
  error
});
